<div class="success-message-wrapper">
  <img loading="lazy" src="assets/img/rewards-program-icons/Check.gif" alt="" />
  <p>{{ message }}</p>
  <button (click)="onClose()">انهاء</button>
</div>
